import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Spinner } from '~/shared/elements';
import ApiError from '~/shared/errors/ApiError';
import Tickets from './Tickets';

const TICKETS = gql`
  {
    clientTickets {
      id
      createdAt
    }
  }
`;

const TicketsData = props => {
  const { data, error, loading } = useQuery(TICKETS);

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  return <Tickets tickets={data.clientTickets} {...props} />;
};

export default TicketsData;
